import React, { useState } from "react";
import styled from "styled-components";
import { FaEnvelope, FaLinkedin, FaGithub, FaInstagram, FaChevronDown, FaChevronUp } from "react-icons/fa";

const Sidebar = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Container $expanded={expanded}>
      {/* Profile Section */}
      <ProfileCard>
        <Avatar src="/avatar.jpg" alt="Profile" />
        <Name>Nishal Dinesh</Name>
        <Role>Full Stack Developer</Role>

        {/* Mobile toggle button */}
        <ToggleButton onClick={() => setExpanded(!expanded)}>
          {expanded ? <FaChevronUp /> : <FaChevronDown />}
        </ToggleButton>
      </ProfileCard>

      {/* Contact + Social Section */}
      <Dropdown $expanded={expanded}>
        <InfoSection>
          <InfoCard>
            <IconBox>
              <FaEnvelope />
            </IconBox>
            <InfoText>
              <Label>Email</Label>
              <Value>hire.ndmedia@gmail.com</Value>
            </InfoText>
          </InfoCard>

          <InfoCard>
            <IconBox>
              <FaLinkedin />
            </IconBox>
            <InfoText>
              <Label>LinkedIn</Label>
              <Value>linkedin.com</Value>
            </InfoText>
          </InfoCard>

          <InfoCard>
            <IconBox>
              <FaGithub />
            </IconBox>
            <InfoText>
              <Label>GitHub</Label>
              <Value>github.com/NishalDinesh124</Value>
            </InfoText>
          </InfoCard>
        </InfoSection>

        <Footer>
          <SocialTray>
            <a href="https://www.linkedin.com/in/nishal-dinesh-710975362" target="_blank" rel="noreferrer">
              <FaLinkedin />
            </a>
            <a href="https://github.com/NishalDinesh124" target="_blank" rel="noreferrer">
              <FaGithub />
            </a>
            <a href="https://www.instagram.com/nishal_dinesh_/" target="_blank" rel="noreferrer">
              <FaInstagram />
            </a>
          </SocialTray>
          <Copyright>©2025 ND Media</Copyright>
        </Footer>
      </Dropdown>
    </Container>
  );
};

export default Sidebar;

/* 🌙 Styled Components */
const Container = styled.aside`
  width: 280px;
  height: 100vh;
  background-color: ${({ theme }) => theme.card};
  border-right: 1px solid ${({ theme }) => theme.border};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 2rem 1.2rem;
  position: fixed;
  left: 0;
  top: 0;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  z-index: 200;

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    padding: 1rem;
    flex-direction: column;
    border-right: none;
    border-bottom: 1px solid ${({ theme }) => theme.border};
  }
`;

const ProfileCard = styled.div`
  background-color: ${({ theme }) => theme.background};
  padding: 1.5rem;
  border-radius: 20px;
  text-align: center;
  width: 100%;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.15);
  position: relative;

  @media (max-width: 768px) {
    background: none;
    box-shadow: none;
    display: flex;
    align-items: center;
    gap: 0.8rem;
    justify-content: space-between;
    padding: 1em;
  }
`;

const Avatar = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 15px;
  object-fit: cover;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    width: 46px;
    height: 46px;
    margin-bottom: 0;
    border-radius: 10px;
  }
`;

const Name = styled.h2`
  font-size: 1.3rem;
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const Role = styled.p`
  font-size: 0.85rem;
  color: ${({ theme }) => theme.subtext};

  @media (max-width: 768px) {
    display: none;
  }
`;

const ToggleButton = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.text};
  font-size: 1.3rem;
  cursor: pointer;
  display: none;

  @media (max-width: 768px) {
    display: block;
  }
`;

const Dropdown = styled.div`
  width: 100%;
  overflow: hidden;
  max-height: ${({ $expanded }) => ($expanded ? "600px" : "0")};
  //padding: ${({ $expanded }) => ($expanded ? "1em" : "0")};
  opacity: ${({ $expanded }) => ($expanded ? 1 : 0)};
  transition: all 0.4s ease;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  @media (min-width: 769px) {
    overflow: visible;
    max-height: none;
    opacity: 1;
  }
`;

const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
`;

const InfoCard = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.background};
  padding: 0.8rem 1rem;
  border-radius: 14px;
  cursor: pointer;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  &:hover {
    border: solid 1px ${({ theme }) => theme.accent};
    transform: translateY(-3px);
    color: #fff;
  }
`;

const IconBox = styled.div`
  font-size: 1.1rem;
  margin-right: 0.9rem;
`;

const InfoText = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.span`
  font-size: 0.7rem;
  opacity: 0.8;
`;

const Value = styled.span`
  font-size: 0.85rem;
  font-weight: 500;
`;

const Footer = styled.footer`
  text-align: center;
  width: 100%;
`;

const SocialTray = styled.div`
  display: flex;
  justify-content: center;
  gap: 1.4rem;
  font-size: 1.3rem;
  margin-bottom: 0.6rem;

  a {
    color: ${({ theme }) => theme.text};
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    width: 36px;
    height: 36px;

    &:hover {
      background-color: ${({ theme }) => theme.hover};
      color: #fff;
      transform: scale(1.1);
      box-shadow: 0 0 8px ${({ theme }) => theme.accent};
    }
  }
`;

const Copyright = styled.p`
  font-size: 0.7rem;
  opacity: 0.6;
`;
